import type { FC } from "react";
import React from "react";

import { bindArgs } from "@core/foundation/function";

import type { LogEntry } from "@apis/calorie-grid/models";

import { CATEGORY_META } from "../../../bootstrap/category.ts";
import { FIGURE_OUTLINE_WIDTH } from "../../../bootstrap/grid.ts";
import { shapeManager } from "../../../shared/lib/ShapeManager.ts";
import { GLYPH_ICONS } from "../lib/glyphs.ts";

const GLYPH_SIZE = 0.62;

const GLYPH_INSET = (1 - GLYPH_SIZE) / 2;

const GLYPH_STROKE = 2.5;

interface LogEntryShapeProps {
  readonly logEntry: LogEntry;
  readonly onSelect: (logEntry: LogEntry) => void;
  // oxlint-disable-next-line no-warning-comments
  // TODO(APT-245): read "now" from a shared reactive context, not a prop.
  readonly today: Date;
}

export const LogEntryShape: FC<LogEntryShapeProps> = ({
  logEntry,
  onSelect,
  today,
}) => {
  const shape = shapeManager.toGridShape(logEntry, today);

  if (!shape.head) {
    return null;
  }

  const categoryColor = CATEGORY_META[logEntry.category].color;

  const Glyph = GLYPH_ICONS[logEntry.glyph];

  return (
    <g
      aria-label={logEntry.name}
      className="cursor-pointer"
      onClick={bindArgs(onSelect, logEntry)}
      role="button"
    >
      <path
        d={shape.outline}
        fill={categoryColor}
        stroke={categoryColor}
        strokeLinejoin="round"
        strokeWidth={FIGURE_OUTLINE_WIDTH}
      />
      <Glyph
        color="white"
        height={GLYPH_SIZE}
        strokeWidth={GLYPH_STROKE}
        width={GLYPH_SIZE}
        x={shape.head.x + GLYPH_INSET}
        y={shape.head.y + GLYPH_INSET}
      />
    </g>
  );
};
